export const CHAT_REQUEST = 'CHAT_REQUEST'
export const CHAT_RESET = 'CHAT_RESET'
export const CHAT_SYSTEM_THINKING = 'CHAT_SYSTEM_THINKING'
export const CHAT_ADD_UTTERANCE = 'CHAT_ADD_UTTERANCE'
export const CHAT_ADD_REPLY = 'CHAT_ADD_REPLY'
export const CHAT_ERROR = 'CHAT_ERROR'
export const CHAT_SELECT_OPTION = 'CHAT_SELECT_OPTION'
export const CHAT_SET_AUDIENCE = 'CHAT_SET_AUDIENCE'
export const CHAT_V2_BATCH_STATUS = 'CHAT_V2_BATCH_STATUS'
export const CHAT_BATCH_IN_PROGRESS = 'CHAT_BATCH_IN_PROGRESS'
